module.exports = __webpack_public_path__ + "static/img/icon.40c09f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon.png
// module id = k3R8
// module chunks = 49